/*import * as Sentry from "@sentry/nextjs";
Sentry.init({
  dsn: "https://7cadf95c3846ebdd27aacc0ae703d753@o4509395776307200.ingest.us.sentry.io/4509395785023488",
    sendDefaultPii: true,
  integrations: [  
    Sentry.replayIntegration(),
  ],
  enableLogs: true,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;*/